export default {"src":"/_next/static/media/mail.0116571c.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};